module.exports = __webpack_public_path__ + "images/kurtosis-04-desktop.png";